<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="small" v-model="searchForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="人员分类">
          <el-select v-model="searchForm.is_waiter" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="id" align="center" label="ID" width="80">
      </el-table-column>
      <el-table-column label="姓名" align="center" prop="user.username" width="120">
      </el-table-column>
      <el-table-column label="头像" align="center" width="120">
        <template slot-scope="scope" v-if="scope.row.user">
          <img v-img-url="scope.row.user.avatarUrl" width="50px" height="50px" />
        </template>
      </el-table-column>
      <el-table-column prop="user.nickName" align="center" label="昵称" width="120">
      </el-table-column>
      <el-table-column prop="grade.name" align="center" label="等级" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.grade">{{ scope.row.grade.name}}</div>
          <div v-else>暂无等级</div>
        </template>
      </el-table-column>
      <el-table-column prop="is_waiter" align="center" label="推广人类型" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_waiter==1">技师</el-tag>
          <el-tag type="danger" v-else>用户</el-tag>
          <!-- <div>{{ scope.row.is_waiter == 1 ? "技师" : "用户" }}</div> -->
        </template>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="推广人手机号" width="120">
      </el-table-column>
      <el-table-column prop="reason" align="center" label="申请原因" width="180">
      </el-table-column>
      <el-table-column prop="balance" align="center" label="余额" width="120">
        <template slot-scope="scope">
          <div style="color:#E6A23C">￥{{scope.row.balance}}元</div>
        </template>
      </el-table-column>
      <el-table-column prop="cash" align="center" label="已提现金额" width="120">
        <template slot-scope="scope">
          <div style="color: #67C23A">￥{{scope.row.cash?scope.row.cash:0.00}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="code" align="center" label="邀请码" width="120"> </el-table-column>
      <el-table-column prop="user_number" align="center" width="120" label="本周期邀请用户数 (1周期为1个月)"> </el-table-column>
      <el-table-column prop="user_sum" align="center" width="120" label="本周期邀请技师数"> </el-table-column>
      <el-table-column prop="waiter_number" align="center" width="120" label="邀请的用户人数"> </el-table-column>
      <el-table-column prop="waiter_sum" align="center" width="120" label="邀请的技师人数"> </el-table-column>

      <el-table-column prop="createTime" align="center" width="120" label="创建时间"> </el-table-column>

      <!-- <el-table-column label="状态">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.statu" active-color="#13ce66" inactive-color="#ccc">
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column fixed="right" align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="delClick(scope.row)">删除</el-button>
          <el-button type="danger" size="small" @click="editClick(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
    <Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Grade>
  </div>
</template>

<script>
import Grade from "./dialog/Grade.vue";
import PromotionApi from "@/api/promotion.js";
export default {
  components: {
    Grade
  },
  data() {
    return {
      open_edit: false,
      options: [
        {
          value: "1",
          label: "技师"
        },
        {
          value: "0",
          label: "用户"
        }
      ],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 4,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        name: "",
        mobile: "",
        is_waiter: ""
      },
      tableData: [
        {
          id: "1",
          date: "2016-05-02",
          nickname: "w",
          mobile: "1566666666",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          order_num: "5",
          address: "上海市普陀区金沙江路 1518 弄",
          orderNo: 200333,
          matinfo: "毛巾",
          pay: "100",
          money: "99.89",
          level: "1",
          use_money: "22.90",
          total_money: "99.89",
          createTime: "2023年8月29日 12:33",
          order_status_text: "已完成",
          pay_type: "微信",
          type: "申请入驻",
          remark: "",
          statu: false,
          imgurl: "https://ruanchengshangmen.rchz.top/image/jishi/clock.png"
        }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      PromotionApi.userList(Params, true)
        .then(data => {
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*删除*/
    delClick(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          PromotionApi.PromotionuserDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    },
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "tag") {
        this.open_tag = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/promotion/promotion/list/index.vue